import React from 'react';
import { Chip } from '@mui/material';
import { TRANSACTION_STATUSES } from '@/utility';
import useTranslatedTransactionStatuses from '@/hooks/useTranslatedTransactionStatuses';

const TransactionStatusChip = ({ status, voidSent }) => {
  const { getTranslatedStatus } = useTranslatedTransactionStatuses();
  const getStatusColor = (statusValue) => {
    if (!statusValue) return 'default';

    const normalizedStatus = statusValue;

    switch (normalizedStatus) {
      case TRANSACTION_STATUSES.SUCCESS:
        return 'success';
      case TRANSACTION_STATUSES.PENDING:
        return 'warning';
      case TRANSACTION_STATUSES.ERROR:
      case TRANSACTION_STATUSES.ACH_RETURNED:
      case TRANSACTION_STATUSES.VOIDED:
        return 'error';
      case TRANSACTION_STATUSES.ACH_SENT:
      case TRANSACTION_STATUSES.SENT_UNCASHED:
        return 'info';
      case TRANSACTION_STATUSES.VOIDED.toLowerCase():
        return 'default';
      case TRANSACTION_STATUSES.ACH_RETURN_AVAILABLE_TO_RECLAIM.toLowerCase():
        return 'success';
      case TRANSACTION_STATUSES.ACH_RETURN_PENDING_RETURN_TO_BANK.toLowerCase():
        return 'warning';
      case TRANSACTION_STATUSES.CANCEL_PENDING:
        return 'warning';
      case TRANSACTION_STATUSES.CANCEL_SUCCESS:
        return 'success';
      case TRANSACTION_STATUSES.CANCEL_FAILURE:
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <div style={{ display: 'flex', gap: '4px' }}>
      <Chip
        label={getTranslatedStatus(status)}
        size='small'
        color={getStatusColor(status)}
        variant='outlined'
      />
      {voidSent && status === TRANSACTION_STATUSES.VOIDED && (
        <Chip
          label='Added to positive pay'
          size='small'
          color='default'
          variant='outlined'
        />
      )}
    </div>
  );
};

export default TransactionStatusChip;
